
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 3a1 1 0 011-1h22a1 1 0 011 1v5a1 1 0 01-1 1h-1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V9H1a1 1 0 01-1-1V3zm20 17V9H4v11h16zm2-13H2V4h20v3zm-12 4a1 1 0 100 2h4a1 1 0 100-2h-4z","fill":"#04080E"}})])
          )
        }
      }
    